import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
import styled from "styled-components";
import { ActionModal } from "./ActionModal/ActionModal";
import { ActionTypeContextProvider } from "./hooks/ActionTypeContext";
import { useActionTypes } from "./hooks/useActionTypes";
import { QuickActionButton } from "./QuickActionButton";
import { QuickActionsHeader } from "./QuickActionsHeader";
export var QuickActionOrigin;
(function (QuickActionOrigin) {
  QuickActionOrigin["HelpCenter"] = "help_center";
  QuickActionOrigin["SelfServe"] = "self_serve";
})(QuickActionOrigin || (QuickActionOrigin = {}));
var QuickActionsBase = function QuickActionsBase(_ref) {
  var origin = _ref.origin,
    hideHeader = _ref.hideHeader;
  var _useActionTypes = useActionTypes(),
    actionTypes = _useActionTypes.actionTypes,
    setActionType = _useActionTypes.setActionType;
  return /*#__PURE__*/React.createElement(QuickActionsWrapper, {
    origin: origin
  }, /*#__PURE__*/React.createElement(QuickActionsHeader, {
    origin: origin,
    hideHeader: hideHeader
  }), actionTypes.map(function (actionType, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, index === 0 ? null : /*#__PURE__*/React.createElement(Spacer, {
      height: "2x"
    }), /*#__PURE__*/React.createElement(QuickActionButton, {
      actionType: actionType,
      setActionType: setActionType,
      origin: origin
    }));
  }), /*#__PURE__*/React.createElement(ActionModal, null));
};
export var QuickActions = function QuickActions(props) {
  return /*#__PURE__*/React.createElement(ActionTypeContextProvider, null, /*#__PURE__*/React.createElement(QuickActionsBase, _objectSpread({}, props)));
};
var QuickActionsWrapper = styled(Column).attrs({
  align: "flex-start"
}).withConfig({
  displayName: "QuickActions__QuickActionsWrapper"
})(["border:", ";padding:", ";width:100%;background-color:", ";height:fit-content;min-width:303px;"], function (props) {
  return props.origin === QuickActionOrigin.HelpCenter ? "1px solid ".concat(Core.border.muted) : "none";
}, getSpacing("2x", "3x", "3x"), function (props) {
  return props.origin === QuickActionOrigin.HelpCenter ? Core.surface.inverse : Core.surface.muted;
});